import { useTranslation } from 'react-i18next';
import { Font } from 'is24-corecss';
import { IconS24DocumentCheck24, IconS24Key24 } from '@is24/cosma-ui-icons';
import type { ReactElement } from 'react';
import WrenchIcon from '@/components/content/welcomeModal/adacUpsell/WrenchIcon';
import styles from '@/components/content/welcomeModal/adacUpsell/Benefits.styles';

export type Benfit = {
  key: 'emergency-locksmith-service' | 'tradesperson-service' | 'ancillary-cost-review';
  icon: ReactElement;
};

const benefits: Benfit[] = [
  { key: 'emergency-locksmith-service', icon: <IconS24Key24 /> },
  {
    key: 'tradesperson-service',
    icon: <WrenchIcon />,
  },
  { key: 'ancillary-cost-review', icon: <IconS24DocumentCheck24 /> },
];

export const Benefits = (props: Pick<HTMLDivElement, 'className'>) => (
  <div className={`grid grid-flex gutter ${props.className}`}>
    {benefits.map((b) => (
      <Benefit key={b.key} benefit={b} />
    ))}
  </div>
);

const Benefit = ({ benefit }: { benefit: Benfit }) => {
  const { t } = useTranslation();

  return (
    <div className='grid-item one-third'>
      <div className='align-center padding-vertical-s'>
        <div className={`${styles.benefitIcon} display-inline-block padding-l`} aria-hidden='true'>
          {benefit.icon}
        </div>
        <Font variant='font-body-medium-xbold' className={`${styles.benefitText} margin-top-m margin-bottom-s`}>
          {t(`common.adacModal.benefits.${benefit.key}.title`)}
        </Font>
        <Font variant='font-body-small-regular' className={styles.benefitText}>
          {t(`common.adacModal.benefits.${benefit.key}.description`)}
        </Font>
      </div>
    </div>
  );
};
